import axiosInstance from "./api";
import MfaFactor, {
  ActivateMfaFactorRequest,
  EnrollMfaFactorRequest,
  MfaEnrollMethod,
  MfaFactorTypeRequest,
} from "./models/mfaFactor.model";
import { enrollMethodToFactorType } from "./utils/helpers/mfaHelpers";

const MFA_API = {
  factors: "/v1/mfa/factors",
  activate: (factorId: string) => `/v1/mfa/factors/${factorId}/activate`,
} as const;

function authHeaders(token: string) {
  return {
    Authorization: `Bearer ${token}`,
  };
}

class MfaService {
  getFactors(token: string): Promise<MfaFactor[]> {
    return axiosInstance
      .get(MFA_API.factors, {
        headers: authHeaders(token),
      })
      .then((res) => res.data.data ?? []);
  }

  enrollFactor(
    token: string,
    factorType: MfaFactorTypeRequest
  ): Promise<MfaFactor> {
    const body: EnrollMfaFactorRequest = { factorType };
    return axiosInstance
      .post(MFA_API.factors, body, {
        headers: authHeaders(token),
      })
      .then((res) => res.data.data);
  }

  enrollByMethod(token: string, method: MfaEnrollMethod): Promise<MfaFactor> {
    return this.enrollFactor(token, enrollMethodToFactorType(method));
  }

  /** @deprecated Prefer enrollByMethod */
  enrollEmailFactor(token: string): Promise<MfaFactor> {
    return this.enrollFactor(token, "email");
  }

  activateFactor(
    token: string,
    factorId: string,
    passCode: string
  ): Promise<MfaFactor> {
    const body: ActivateMfaFactorRequest = { passCode };
    return axiosInstance
      .post(MFA_API.activate(factorId), body, {
        headers: authHeaders(token),
      })
      .then((res) => res.data.data);
  }
}

export default new MfaService();
